import { render, staticRenderFns } from "./ProductTypeBulkForm.vue?vue&type=template&id=f35653ee&scoped=true&"
import script from "./ProductTypeBulkForm.vue?vue&type=script&lang=js&"
export * from "./ProductTypeBulkForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypeBulkForm.vue?vue&type=style&index=0&id=f35653ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35653ee",
  null
  
)

export default component.exports